module.exports = __webpack_public_path__ + "static/media/acco-150x150.49dd0bc2.png";